<button :class="[ color, size, { disabled }, type ]" @click="click"><slot></slot></button>